import Axios from 'src/utils/axiosConfig';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  SET_COUNTS, SET_COUNT_ERROR, LOADING_COUNTS,
} from '../types';

export const getCounts = () => async (dispatch) => {
  dispatch({ type: LOADING_COUNTS, value: true });
  try {
    const result = await Axios.get('/utilities/counts');
    dispatch({ type: LOADING_COUNTS, value: false });
    dispatch({ type: SET_COUNTS, counts: result.data.data });
  } catch (error) {
    dispatch({ type: LOADING_COUNTS, value: false });
    dispatch({ type: SET_COUNT_ERROR, error: error.message });
  }
};

export const getUserInfo = createAsyncThunk('user/info', async (payload, { rejectWithValue }) => {
  try {
    const result = await Axios.get(`users/${payload.uid}`);
    const { data } = result.data;

    const info = {
      ...data,
      sessionData: payload.sessionData,
    };

    return info;
  } catch (error) {
    console.log('Error: ', error);
    if (error.response) {
      const { message } = error.response.data;
      return rejectWithValue(message);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});

export const filterUsers = createAsyncThunk('user/all', async (payload, { rejectWithValue }) => {
  try {
    const { pageSize, page } = payload;

    const queryParams = `?page=${page}&pageSize=${pageSize}`;
    const bodyData = {};

    if (payload.roleId) {
      bodyData.roleId = payload.roleId;
    }

    if (payload.gender) {
      bodyData.gender = payload.gender;
    }

    if (payload.statusId) {
      bodyData.statusId = payload.statusId;
    }

    const result = await Axios.post(`admin/users/filter${queryParams}`, bodyData);
    return result.data;
  } catch (error) {
    if (error.response) {
      const { message } = error.response.data;
      return rejectWithValue(message);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});

export const fetchAssignedDistributors = createAsyncThunk('user/distributors/assigned', async (payload, { rejectWithValue }) => {
  try {
    const result = await Axios.get(`users/distributor/assigned?salesUserId=${payload}`);
    return result.data;
  } catch (error) {
    if (error.response) {
      const { message } = error.response.data;
      return rejectWithValue(message);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});

export const fetchActiveDistributors = createAsyncThunk('user/distributors/active', async (_, { rejectWithValue }) => {
  try {
    const result = await Axios.get('users/distributor/active');
    return result.data;
  } catch (error) {
    if (error.response) {
      return rejectWithValue(error.response.data);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});

export const updateUser = createAsyncThunk('user/update', async (payload, { rejectWithValue }) => {
  try {
    const { user, id } = payload;
    const result = await Axios.patch(`users/${id}`, user);
    return result.data;
  } catch (error) {
    if (error.response) {
      return rejectWithValue(error.response.data);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});

export const assignDistributor = createAsyncThunk('user/distributor/assign', async (payload, { rejectWithValue }) => {
  try {
    const { salesUserId, distributorId } = payload;

    const queryParams = `?salesUserId=${salesUserId}&distributorId=${distributorId}`;

    const result = await Axios.get(`users/assign/distributor${queryParams}`);
    return result.data;
  } catch (error) {
    if (error.response) {
      const { message } = error.response.data;
      return rejectWithValue(message);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});

export const unAssignDistributor = createAsyncThunk('user/distributor/unassign', async (payload, { rejectWithValue }) => {
  try {
    const { salesUserId, distributorId } = payload;

    const queryParams = `?salesUserId=${salesUserId}&distributorId=${distributorId}`;

    const result = await Axios.get(`users/unassign/distributor${queryParams}`);
    return result.data;
  } catch (error) {
    if (error.response) {
      const { message } = error.response.data;
      return rejectWithValue(message);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});
